<template>
  <div class="UpdateStudentCom" style="margin-right: 10px">
    <el-button type="text" size="small" @click="showDialog">家长管理</el-button>
    <el-dialog
      :center="true"
      custom-class="el__dialog"
      :visible.sync="flag"
      title="编辑家长信息"
      :lock-scroll="true"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :before-close="studentFields"
      width="800px"
    >
      <!-- <el-scrollbar style="height: 680px;"> -->
      <p class="dialog__content__title" style="margin-bottom: 10px">
        家长信息：
      </p>

      <div v-for="(item, index) in parentList" :key="item.id">
        <el-form
          :rules="updateRules"
          :inline="true"
          :model="item"
          ref="UpdateForm"
          class="demo-form-inline"
          style="display: flex"
        >
          <el-form-item prop="name">
            <el-input
              style="width: 100px"
              v-model="item.name"
              :disabled="nowUpdating != index"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item class="el__item" prop="relation">
            <el-select
              clearable
              v-model="item.relation"
              style="width: 100px"
              filterable
              :disabled="nowUpdating != index"
            >
              <el-option
                v-for="item in relationList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mobile">
            <el-input
              v-model="item.mobile"
              placeholder="请填写您的手机号"
              :disabled="nowUpdating != index"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="authSource == 'system'">
            <el-button
              size="mini"
              type="primary"
              @click="onChangeUpdate(index)"
              v-if="nowUpdating != index"
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              type="primary"
              @click="onUpdateParent(item, index)"
              v-if="nowUpdating == index"
            >
              确认
            </el-button>
            <el-button
              size="mini"
              type="primary"
              @click="onResetParent('parent', item)"
              >重置密码
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="onUnbindParent(item.id)"
              >删除</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <!-- 家长信息添加 -->
      <div v-if="isAdd">
        <div div v-for="item in addParentList" :key="item.id">
          <el-form
            :rules="updateRules"
            :inline="true"
            :model="item"
            ref="ParentForm"
            class="demo-form-inline"
          >
            <el-form-item prop="name">
              <el-input
                style="width: 100px"
                v-model="item.name"
                placeholder="家长姓名"
                maxlength="20"
              ></el-input>
            </el-form-item>

            <el-form-item prop="relation" class="el__item">
              <el-select
                clearable
                v-model="item.relation"
                style="width: 100px"
                filterable
                placeholder="关系"
              >
                <el-option
                  v-for="_item in relationList"
                  :key="_item"
                  :label="_item"
                  :value="_item"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="mobile">
              <el-input
                v-model="item.mobile"
                placeholder="请填写您的手机号码"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="mini"
                :disabled="!item.isAdd"
                type="primary"
                @click="onSubmit(item)"
              >
                {{ item.isAdd ? '确认添加' : '已添加' }}
              </el-button>
              <el-button size="mini" type="danger" @click="onDel(item.id)"
                >删除</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>

      <el-button
        v-if="authSource == 'system'"
        size="mini"
        type="primary"
        style="margin-left: 0"
        @click="onAddParent"
      >
        添加联系人
      </el-button>
      <!-- </el-scrollbar> -->

      <el-row type="flex" justify="end">
        <el-button size="small" @click="hidedialogflag">取消</el-button>
        <el-button size="small" type="primary" @click="hidedialogflag"
          >确定</el-button
        >
      </el-row>
      <div style="height: 20px; width: 100%"></div>
    </el-dialog>
  </div>
</template>
<script>
import {
  studentCheckParent,
  saveStudent,
  dictCode,
  onAddParent,
  unbindParent,
  resetPassword,
} from '@/api/home'

export default {
  name: 'UpdateParentCom',
  props: {
    relationList: {
      type: Array,
    },
    gradeList: {
      type: Array,
    },
    nationList: {
      type: Array,
    },
    studentObj: {
      type: Object,
    },
    parentList: {
      type: Array,
    },
    classes: {
      type: Object,
    },
    parentEdit: {
      type: Object,
    },
  },
  data() {
    const checkphone = (rule, value, callback) => {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请填写正确的手机'))
      } else {
        studentCheckParent({ phone: value })
          .then(() => {
            callback()
          })
          .catch((error) => {
            return callback(new Error(error))
          })
      }
    }
    const checkOnAddphone = (rule, value, callback) => {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请填写正确的手机'))
      } else {
        callback()
      }
    }
    const checkidCard = (rule, value, callback) => {
      let _id_reg =
        /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}[\dXx]$/
      if (value && !_id_reg.test(value)) {
        callback(new Error('请填写正确的身份证号'))
      } else {
        callback()
      }
    }
    return {
      authSource: '',
      updateTemp: {}, //编辑家长信息时的临时变量
      flag: false,
      isAdd: false,
      student: {
        id: '',
        name: '', // 姓名
        rosterNo: '', // 学籍号
        address: '', // 家庭住址
        birth: '', // 生日
        idCard: '', // 身份证号码
        nation: '汉族', // 民族
        nativePlace: '', // 籍贯
        political: '', // 政治面貌
        sex: '', // 性别
        gradeId: '', // 年级
        classesId: '', // 班级
        schoolId: localStorage.getItem('userId'),
      },
      // addParentForm: {
      //   name: '',
      //   relationship: '',
      //   phone: '',
      // },
      // parent: {
      //   name: '',
      //   mobile: '',
      //   relation: '',
      //   schoolId: localStorage.getItem('userId'),
      // },
      politicsList: {},
      parentMsgId: 0,
      addParentList: [],
      parent: {
        // schoolId:localStorage.getItem('userId'),
        name: '',
        mobile: '',
        relation: '',
      },
      // classesList: [],
      studentRules: {
        name: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        rosterNo: [
          {
            required: true,
            message: '学籍号不能为空',
            trigger: ['blur'],
          },
          {
            min: 6,
            message: '学籍号至少6位及以上',
            trigger: ['blur'],
          },
        ],
        idCard: [
          {
            required: false,
            validator: checkidCard,
            trigger: ['blur'],
          },
        ],
        gradeId: [
          {
            required: true,
            message: '年级不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        classesId: [
          {
            required: true,
            message: '班级不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        phone: [
          {
            required: true,
            validator: checkOnAddphone,
            trigger: ['blur', 'change'],
          },
        ],
        relationship: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change'],
          },
        ],
      },
      updateRules: {
        // name: [
        //   {
        //     required: true,
        //     message: '姓名不能为空',
        //     trigger: ['blur', 'change'],
        //   },
        // ],
        mobile: [
          {
            required: true,
            validator: checkOnAddphone,
            trigger: ['blur', 'change'],
          },
        ],
        relation: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change'],
          },
        ],
      },
      nowUpdating: -1,
    }
  },
  computed: {
    classesList() {
      let _arr = []
      this.gradeList.forEach((k) => {
        if (k.gradeId == this.student.gradeId) {
          _arr = k.classesList
          return _arr
        }
      })
      return _arr
    },
  },
  watch: {
    $props: {
      deep: true,
      immediate: true,
      handler() {
        this.student = { ...this.studentObj, ...this.classes }
        // this.student.parent = this.parentList[0] || this.parent
        this.parent = { ...this.parentList }
      },
    },
  },
  mounted() {
    this.authSource = localStorage.getItem('authSource')
    this.type = localStorage.getItem('type')
    if (this.type == 8) {
      // 更改校验规则
      this.studentRules.rosterNo = [
        {
          required: true,
          message: '学员编号不能为空',
          trigger: ['blur'],
        },
        {
          min: 6,
          message: '学员编号至少6位及以上',
          trigger: ['blur'],
        },
      ]
    }
  },
  // created() {
  //   console.log(this.$props.parentList)
  // },
  methods: {
    //点击编辑按钮时
    onChangeUpdate(index) {
      var isValid = false
      if (this.nowUpdating != -1) {
        this.$refs['UpdateForm'][this.nowUpdating].validate((valid) => {
          if (!valid) {
            return
          } else {
            this.nowUpdating = index
          }
        })
      } else {
        this.nowUpdating = index
      }
    },
    //重置家长密码
    onResetParent(roleType, obj) {
      // console.log(this.student)
      // return
      this.$confirm(
        `您确定要重置<span style="color:#409EFF;margin:0 10px;">${
          this.student.name + ' '
        }${
          roleType == 'parent' ? '家长' : '学生'
        }</span>的密码么?重置后的密码是000000`,
        '重置密码',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let data = {
            roleType,
            userId: roleType == 'parent' ? obj.id : this.student.id,
          }
          resetPassword({ ...data }).then(() => {
            this.$message({
              type: 'success',
              message: '重置成功',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置',
          })
        })
    },
    //修改家长信息
    onUpdateParent(item, index) {
      // console.log(this.$refs['UpdateForm'][index])
      this.$refs['UpdateForm'][index].validate(async (valid) => {
        if (valid) {
          item.studentId = this.student.id
          let res = await onAddParent(item)
          let { code } = res.data
          if (code == 0) {
            this.$message({
              message: '修改成功',
              type: 'success',
            })
            this.nowUpdating = -1
          } else {
            this.$message({
              message: '修改失败',
              type: 'info',
            })
          }
        } else {
          return false
        }
      })
    },
    //解除绑定家长
    async onUnbindParent(id) {
      let params = {
        parentId: id,
        studentId: this.student.id,
      }
      let res = await unbindParent(params)
      if (res.data.code == 0) {
        // console.log(res)
        this.parentList.splice(
          this.parentList.findIndex((item) => {
            return item.id == id
          }),
          1
        )
        this.$message.success('删除成功!')
      }
    },
    // 添加一名家长按钮
    //目前策略是一个一个添加，添加后提交更新家长列表
    onAddParent() {
      if (this.isAdd) {
        return
      } else {
        this.addParentList.push({
          id: this.parentMsgId++,
          name: '',
          relation: '',
          mobile: '',
          isAdd: true,
        })
        this.isAdd = true
        this.nowUpdating = -1
      }
    },
    // 添加一条家长信息提交时
    onSubmit(data) {
      let params = {
        // id: data.id,
        studentId: this.student.id,
        schoolId: localStorage.getItem('userId'),
        name: data.name,
        mobile: data.mobile,
        relation: data.relation,
      }

      this.$refs['ParentForm'][0].validate(async (valid) => {
        if (valid) {
          let res = await onAddParent(params)
          let { code } = res.data
          if (code == 0) {
            this.$message({
              message: '添加成功',
              type: 'success',
            })
            this.isAdd = false
            params.id = res.data.data
            console.log(params.id)
            this.parentList.push(params)
            this.addParentList.forEach((item, index) => {
              if (data.id == item.id) {
                // console.log(item)
                item.isAdd = false
              }
            })
            this.addParentList = []
          } else {
            this.$message({
              message: '添加失败',
              type: 'info',
            })
          }
        } else {
          // this.$message({
          //   message: '添加失败',
          //   type: 'info',
          // })
          return false
        }
      })
    },

    // 删除添加的这条家长信息(未提交时)
    onDel(id) {
      // console.log(id)
      this.addParentList.forEach((item, index) => {
        if (item.id == id) {
          this.addParentList.splice(index, 1)
          this.$message({
            message: '删除成功',
            type: 'success',
          })
        }
        this.isAdd = false
      })
    },

    studentFields() {
      this.flag = false
      this.$refs.student.resetFields()
    },
    showDialog() {
      this.dictCode()
      this.flag = true
    },
    hidedialogflag() {
      this.flag = false
      this.resetForm('UpdateForm')
      this.student = { ...this.studentObj, ...this.classes }
      this.$emit('updateList')
      // this.student.parent = this.parentList[0] || this.parent
    },
    resetForm(formName) {
      this.$refs[formName][0].resetFields()
    },
    changeclassesList() {
      this.student.classesId = ''
    },
    ApiSaveStudent() {
      let data = {}
      if (!this.parent.name || !this.parent.mobile || !this.parent.relation) {
        data = {
          classesId: this.student.classesId,
          gradeId: this.student.gradeId,
          student: { ...this.student },
        }
      } else {
        data = {
          classesId: this.student.classesId,
          gradeId: this.student.gradeId,
          student: { ...this.student },
          parent: {
            ...this.parent,
            schoolId: localStorage.getItem('schoolIds'),
          },
        }
      }
      saveStudent({ ...data }).then((res) => {
        if (res.data.code !== '0') {
          return false
        }
        this.hidedialogflag()
        this.$message({
          message: '修改成功',
          type: 'success',
        })
        this.$emit('updateList')
      })
    },

    // 字典  查询政治面貌
    async dictCode() {
      const { data: res } = await dictCode({
        code: 'political_type',
      })
      this.politicsList = res.data
    },
    Submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.parent.name || this.parent.mobile || this.parent.relation) {
            if (!/^1[0-9]{10}$/.test(this.parent.mobile)) {
              console.log(this.parent.mobile)
              this.$message.error('请填写正确的家长手机号哦！')
              return false
            }
            if (this.parent.name == '' || this.parent.name == null) {
              this.$message.error('家长姓名是必填的哦！')
              return false
            } else if (this.parent.mobile == '' || this.parent.mobile == null) {
              this.$message.error('家长手机号是必填的哦！')
              return false
            } else if (
              this.parent.relation == '' ||
              this.parent.relation == null
            ) {
              this.$message.error('关系是必选的哦！')
              return false
            }
          }
          // console.log('this.parent.relation', this.parent.relation)
          this.ApiSaveStudent()
          this.$refs[formName].resetFields()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.UpdateStudentCom {
  display: inline-block;
}
.UpdateStudentCom .el-form-item {
  margin: 20px 0;
}
.UpdateStudentCom .el-input__inner {
  width: 100%;
}
.el__dialog.el-dialog {
  max-height: 90vh;
  overflow: auto;
  margin: 5vh auto !important;
}
.el-button {
  margin-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/components/updateParent.vue